var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeoVimLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#F4F2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 71.0063L88.5954 28V227.957L46 185.45V71.0063Z",
    fill: "url(#paint0_linear_306_34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.584 71.4104L167.406 28.0225L168.282 227.958L210.878 185.45L210.584 71.4104Z",
    fill: "url(#paint1_linear_306_34)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5672 28.0332L199.309 197.012L168.32 228L57.5195 59.3947L88.5672 28.0332Z",
    fill: "url(#paint2_linear_306_34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6046 106.416L88.5462 113.072L54.3527 62.5927L57.5193 59.3677L88.6046 106.416Z",
    fill: "black",
    fillOpacity: 0.13
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_34",
    x1: 67.2972,
    y1: 28,
    x2: 67.2972,
    y2: 227.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16B0ED",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F59B2",
    stopOpacity: 0.837
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_34",
    x1: 189.14,
    y1: 28.0225,
    x2: 189.14,
    y2: 227.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DB643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367533"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_34",
    x1: 128.414,
    y1: 28.0332,
    x2: 128.414,
    y2: 228.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C649",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439240",
    stopOpacity: 0.84
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoVimLight);
export default __webpack_public_path__ + "static/media/NeoVim-Light.bf26aaca8b528ee2bcf79f978324a69f.svg";
export { ForwardRef as ReactComponent };